import React, { useEffect, useState } from 'react';
import { Formik, Field, Form } from 'formik';
import * as Yup from 'yup';
import { useTranslation } from "react-i18next";
import PropTypes from 'prop-types';
import { Box } from "@material-ui/core";

import AppInput from "../../../../components/Input/AppInput";
import AppButton from "../../../../components/CustomButtons/AppButton";
import { YupValidations } from 'utils/validate';
import AppConfig from 'config/AppConfig';
const { PATTERNS } = AppConfig
const AdminProfileForm = props => {
  const {
    onSubmit,
    initData,
    isSubmitting
  } = props;

  const { t } = useTranslation();

  const [initializeData, setInitializeData] = useState({
    firstName: '',
    lastName: '',
    email: ''
  });

  useEffect(() => {
    if(initData && Object.keys(initData).length > 0) {
      setInitializeData({
        firstName: initData.firstName || '',
        lastName: initData.lastName || '',
        email: initData.email || ''
      });
    }
  }, [initData])

  return (
    <Formik
      initialValues={initializeData}
      validationSchema={Yup.object().shape({
        firstName: Yup.string().required('validation.first_name.required').max(64, "validation.max_length_64").matches(PATTERNS.BLANK_SPACES, 'validation.blankSpaces'),
        lastName: Yup.string().required('validation.last_name.required').max(64, "validation.max_length_64").matches(PATTERNS.BLANK_SPACES, 'validation.blankSpaces'),
        email: YupValidations.email
      })}
      onSubmit={onSubmit}
      enableReinitialize
    >
      {() => (
        <Form>
          <Field
            component={AppInput}
            name="email"
            label={t('label.email')}
            required
            disabled
          />
          <Field
            component={AppInput}
            name="firstName"
            label={t('label.first_name')}
            required
          />
          <Field
            component={AppInput}
            name="lastName"
            label={t('label.last_name')}
            required
          />
          <Box display="flex" justifyContent="flex-end" alignItems="center" mt={3}>
            <AppButton
              label={t('button.save')}
              type="submit"
              isLoading={isSubmitting}
              disabled={isSubmitting}
            />
          </Box>
        </Form>
      )}
    </Formik>
  )
}

AdminProfileForm.propTypes = {
  onSubmit: PropTypes.func,
  initData: PropTypes.any,
  isSubmitting: PropTypes.bool
};

export default AdminProfileForm;
